Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.HideEmptyAlbumWidget = Marionette.Behavior.extend({
        initialize: function() {
            if (!_.isFalsy(App.displayOptions.get('hideIfLessThan')) || !_.isFalsy(gon.current_account.extra_fields.hideIfLessThan)) {
                $('html').css('opacity', 0);
            }
        },
        collectionEvents: {
            'sync': function() {
                var _this = this;

                //allows customers to subscribe to this event
                var messageParentFrame = function() {
                    var msg = {
                        name: 'pixlee:widget:num:photos',
                        type: 'action',
                        source: 'widget',
                        destination: 'parent',
                        data: {
                            photoCount: _this.view.collection ? _this.view.collection.length : 0
                        }
                    };
                    window.top.postMessage(JSON.stringify(msg), '*');
                };

                var interval = setInterval(function() {
                    if ('parentIFrame' in window) {
                        if (!_this.view.collection.length && _.isFalsy(App.displayOptions.get('is_interactive'))) {
                            window.parentIFrame.close();
                        } else if (!_.isFalsy(App.displayOptions.get('hideIfLessThan')) || !_.isFalsy(gon.current_account.extra_fields.hideIfLessThan)) {
                            var imageLimit = !_.isFalsy(App.displayOptions.get('hideIfLessThan')) ? App.displayOptions.get('hideIfLessThan') : gon.current_account.extra_fields.hideIfLessThan;
                            var widgetType = gon.type;
                            var photoCount = _this.view.collection.length;

                            if (widgetType === 'carousel') {
                                // a carousel widget includes uploader tiles as part of the collection
                                // so this variable returns a new collection minus the uploader tiles
                                var collectionWithoutTiles = _this.view.collection.reject(function (model) {
                                    return model.get('isUploaderTile');
                                });

                                // widgets can have a max of 2 uploader tiles; front and/or end
                                photoCount = collectionWithoutTiles.length;
                            }

                            if (photoCount < imageLimit && _.isFalsy(App.displayOptions.get('is_interactive'))) {
                                window.parentIFrame.close();
                            } else {
                                $('html').css('opacity', 1);
                                $('#header_wrapper').css('visibility', 'visible');
                            }
                        } else if (!_this.view.collection.length && _.isFalsy(gon.previewMode) && !_this.checkedCollection) {
                            $('.btn').hide();
                        } else {
                            $('#header_wrapper').css('visibility', 'visible');
                            if (_.indexOf(App.currentUser.get('features'), 'remove_powered_by') === -1) { //I believe underscore's indexOf is polyfilled unlike Array.prototype.indexOf
                                //if there's images then we want to show the powered by logo
                                var msg = {
                                    name: 'pixlee:generate:attribution:link',
                                    type: 'action',
                                    source: 'widget',
                                    destination: 'parent',
                                    data: {
                                        src: window.location.href,
                                        isSimple: gon.current_album.album_type === 'standard' || gon.current_album.album_type === 'story' || gon.current_album.album_type === 'influencer_campaign' || gon.current_album.album_type === 'posts',
                                        landingPageURL: gon.current_account.extra_fields.landing_page_url,
                                        disablePoweredByClick: App.displayOptions.get('disablePoweredByClick')
                                    }
                                };

                                window.parent.postMessage(JSON.stringify(msg), '*');
                            }
                        }
                        messageParentFrame();

                        _this.checkedCollection = true;
                        clearInterval(interval);
                    }
                }, 32);
            }
        }
    });
});
